// extracted by mini-css-extract-plugin
export default {"agreement":"AgreementTextV2_agreement-z6_","agreementText":"AgreementTextV2_agreementText-oql","copyright":"AgreementTextV2_copyright-BI7","payments":"AgreementTextV2_payments-qqG"};